import { ApplicationStatus } from '@/apis/family_application/requests'
import { AppRoutePaths } from '@/routing/route_paths'
import { ProgramSettingsResp } from '@/storage/program_settings/requests'
import { EXCLUDED_PAGES_PER_STATUS } from './application-status.constants'

type IsValidRouteArgs = {
  pathname: string
  applicantStatus: ApplicationStatus
  programSettings: ProgramSettingsResp
}

export function isValidRoute({
  applicantStatus,
  pathname,
  programSettings,
}: IsValidRouteArgs) {

  const scholars: ApplicationStatus[] = [
    'Awarded',
    'Appeal',
    'Funded',
    'ClassWallet Renewal',
    'SoftPoint Renewal',
  ] as const

  const isScholar = scholars.includes(applicantStatus)
  const isClassWalletPage = pathname.includes(
    AppRoutePaths.external.classWallet
  )
  const isMarketplace = pathname.includes(
    AppRoutePaths.marketplace.index
  )
  const isPayProvider = pathname.includes(
    AppRoutePaths.providers.index
  )
  const isReimbursement = pathname.includes(
    AppRoutePaths.reimbursements.index
  )

  if (isReimbursement)
    return programSettings.reimbursement_module == 1
  
  if (isPayProvider)
    return programSettings.pay_provider_module == 1

  if (isMarketplace)
    return programSettings.marketplace_module == 1

  if (isClassWalletPage) {
    return isScholar && programSettings.class_wallet
  }

  return !EXCLUDED_PAGES_PER_STATUS[applicantStatus]?.includes(pathname)
}
